import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import router from '@/router'

const http = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
    if (localStorage.getItem('user_token')) {
        config.headers.Authorization = localStorage.getItem('user_token')
    }
    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
    return response
}, error => {
    // 当响应异常时
    let isTimeout = error.toString().includes('timeout')
    if (isTimeout) {
        Vue.prototype.$message({
            message: '请求超时...',
            type: 'warning',
            duration: 2000,
            showClose: true
        })
    }
    let isLogTimeout = error.toString().includes('401')

    if (isLogTimeout) {
        Vue.prototype.$message({
            message: '登录已过期',
            type: 'warning',
            duration: 2000,
            showClose: true
        })
        localStorage.setItem("isLoginTimeOut", "true");
        router.push('/login') //成功跳转到首页
    }
    let isNotpermision = error.toString().includes('405')
    if (isNotpermision) {
        Vue.prototype.$message({
            message: '没有访问权限',
            type: 'warning',
            duration: 2000,
            showClose: true
        })
    }

    let isError500 = error.toString().includes('500')
    if (isError500) {
        Vue.prototype.$message({
            message: '500服务器错误！',
            type: 'error',
            duration: 2000,
            showClose: true
        })
    }

    return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
    return process.env.VUE_APP_SERVER_URL + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
    var defaults = {
        't': new Date().getTime()
    }
    return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
    var defaults = {
        't': new Date().getTime()
    }
    data = openDefultdata ? merge(defaults, data) : data
    return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http
